<template>
  <div>
    <div class="document-container">
      <div class="columns">
        <div class="column is-three-quarters">
          <div class="document" style="height:100%">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    Process Details
                  </div>
                  <div class="header-subtitle">
                    Displays details about processing.
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <es-form>
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon :icon="['fas', 'chart-line']" size="lg"/>
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Status Statistics
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <table v-if="transaction" class="table is-fullwidth">
                    <thead>
                      <tr>
                        <th class="column-header has-text-grey">
                          Match Status
                        </th>
                        <th class="text-align--right has-text-grey"
                          v-if="!loading && transactionStatusGroup.length"
                        >
                          Record Count
                        </th>
                      </tr>
                    </thead>
                    <es-loader v-if="loading" style="margin: 5rem"/>
                    <es-exception
                      v-if="!loading && !dataLoaded"
                      style="margin: 3.5rem !important"
                      exceptionMessage="No processing status is available."
                    />
                    <tbody v-if="!loading && dataLoaded">
                      <tr
                        class="batch-category has-text-weight-bold"
                        v-for="(category,index) in transactionStatusGroup"
                        :key="index"
                      >
                        <td colspan="2" style="border-bottom: 0; padding: 0">
                          <table role="presentation"
                            class="table is-fullwidth"
                            style="margin: 0 1rem 0.5rem 0"
                          >
                            <tbody>
                              <tr class="group-name">
                                <td
                                  class="has-text-weight-bold removeUnderline"
                                  colspan="2"
                                  style="padding-bottom: 0"
                                >
                                  {{ category.groupName }}
                                  <!-- Near Match System Label needed -->
                                </td>
                              </tr>
                              <tr
                                class="row-border"
                                v-for="(subcategory, index) in category.list
                                  .filter(l => l.showThisStatus)"
                                :key="index"
                              >
                                <td
                                  class ="has-text-grey font-weight"
                                  style="padding: 0 0 0 1rem; color: #666 !important"
                                >
                                  <span v-if="subcategory.prefix">
                                    {{ subcategory.prefix }}:
                                  </span>
                                  {{ subcategory.description }}
                                  <!-- Near Match System Label needed -->
                                </td>
                                <td
                                  class ="text-align--right font-weight record-count"
                                  style="padding: 0 1rem 0 0"
                                >
                                  1
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </es-form>
              <!-- <es-form>
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon :icon="['fas', 'clock']" size="lg"/>
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Processing Stage
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <table v-if="transaction" class="table is-fullwidth">
                    <thead>
                      <th class="column-header has-text-grey">
                        Stage
                      </th>
                      <th class="text-align--right has-text-grey">
                        Processing Date
                      </th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item,index) in transaction.processingStages.stages"
                        :key="index"
                      >
                        <template v-for="(date,stage,i) in item">
                          <td class ="has-text-grey">
                            {{ stage }}
                          </td>
                          <td class="text-align--right">
                            {{ date | formatDateMMDDYYYYHHMM }}
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </es-form> -->
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div class="document margin-bottom">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    Next Steps
                  </div>
                </template>
              </EsHeader>
            </div>
            <div
              class="is-flex flex-direction--column flex-align--start"
              style="padding: 1rem"
            >
              <div
                v-if="hasModule('PRSID:MATCH:RESOLVENM:VIEW') && this.transaction.open"
                class="margin-bottom--small"
              >
                <router-link
                  :to="{
                    path: '/personid/nearMatches',
                    query: {
                      pidSubmissionId: this.transaction.pidSubmissionId,
                      pidBatchId: this.transaction.pidBatchId
                    },
                  }"
                  class="button is-primary has-no-underline"
                >
                  Resolve
                </router-link>
              </div>
              <div
                v-if="hasModule('PRSID:DWNLD:DOWNLOAD')
                  && isDownloadTypesAllowed"
                class="margin-bottom"
              >
                <router-link
                  :to="{ name: 'PITransactionInfoDownload' }"
                  class="button is-primary has-no-underline"
                  aria-label="Download Transaction"
                  role="button"
                >
                  Download
                </router-link>
              </div>
              <div v-if="hasModule('PRSID:MATCH:HISTORY:VIEW')">
                <router-link
                  :to="{
                      path: `/personId/batch/${transaction.pidBatchId}/details`
                    }"
                >
                  View Batch Profile
                </router-link>
              </div>
            </div>
          </div>
          <div class="document">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    General Information
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <table v-if="transaction" class="form-table table is-fullwidth" role="presentation">
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    {{ getFieldLabel(`PER:${personType}:ASSIGN:DISTRICT_CODE`) }}
                  </td>
                  <td class="text-align--right font">
                    {{ transaction.districtName }}
                    ({{ transaction.districtCode }})
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    {{ getFieldLabel(`PER:${personType}:ASSIGN:SCHOOL_CODE`) }}
                  </td>
                  <td class="text-align--right font">
                    {{ transaction.schoolName }}
                    ({{ transaction.schoolCode }})
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    Extract Date
                  </td>
                  <td class="text-align--right font">
                    {{ formatExtractDate(transaction.createdDate) }}
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    Extract File
                  </td>
                  <td class="text-align--right max-width font">
                    <span
                      v-if="transaction.pidBatch.submissionTypeCode === 'FILE' ||
                        transaction.pidBatch.submissionTypeCode === 'AFP'"
                    >
                      {{ transaction.pidBatch.fileName }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    Transmission ID
                  </td>
                  <td class="text-align--right font">
                    <span v-if="transaction.pidBatch.transmissionId">
                      {{ transaction.pidBatch.transmissionId }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    {{ getFieldLabel(`PER:${personType}:ASSIGN:SOURCE_CODE`) }}
                  </td>
                  <td class="text-align--right font">
                    {{ transaction.pidSubmission.sourceCode }}
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    Creation Date
                  </td>
                  <td class="text-align--right font">
                    {{ formatDateTime(transaction.pidBatch.createdDate) }}
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    Creation User
                  </td>
                  <td class="text-align--right font">
                    {{ transaction.createdByFirstName +' '+ transaction.createdByLastName }}
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey align-bottom">
                    Delimiter (Record)
                  </td>
                  <td class="text-align--right font">
                    <span v-if="transaction.pidBatch.fileRecordDelimiter">
                      {{ transaction.pidBatch.fileRecordDelimiter }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    Delimiter (Header)
                  </td>
                  <td class="text-align--right font">
                    <span v-if="transaction.fileRecordQualifier">
                      {{ transaction.fileRecordQualifier }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </td>
                </tr>
                <tr class= "form-row">
                  <td class="text-align--left has-text-grey">
                    File Version
                  </td>
                  <td class="text-align--right font">
                    <span v-if="transaction.pidBatch.fileVersion">
                      {{ transaction.pidBatch.fileVersion }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChartLine,
  faClock,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faChartLine,
  faClock,
  faExclamationTriangle,
);
export default {
  mixins: [
    FieldLabels,
    PermissionManager,
  ],
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
  },
  props: [
    'transaction',
  ],
  watch: {
    pidTransactionStatuses(newValue) {
      if (newValue.length > 0) {
        this.allTransactionStatusGroup();
      }
    },
    transactionStatusGroup() {
      if (this.transactionStatusGroup.length > 0) {
        this.dataLoaded = true;
      }
    },
  },
  data() {
    return this.initialData();
  },
  async created() {
    this.userPersonTypesCodes = this.userPersonTypes
      .map(item => item.code);
  },
  computed: {
    ...mapGetters([
      'userPersonTypes',
    ]),
    ...mapGetters('lookups', [
      'pidTransactionStatuses',
      'defaultPersonType',
    ]),
    allowedExtractDownloadTypes() {
      return this.$store.state.propertiesModule.properties['PERSON-EXTRACT_DOWNLOAD_TYPES_ALLOWED'];
    },
    isDownloadTypesAllowed() {
      if (this.allowedExtractDownloadTypes) {
        return this.allowedExtractDownloadTypes
          .includes(this.transaction.pidBatch.submissionTypeCode);
      }
      return null;
    },
    personType() {
      if (this.userPersonTypesCodes.includes(this.defaultPersonType)) {
        return this.defaultPersonType;
      } return this.userPersonTypesCodes[0];
    },
  },
  mounted() {
    this.allTransactionStatusGroup();
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionStatuses',
    ]),
    allTransactionStatusGroup() {
      setTimeout(() => {
        const result = this.pidTransactionStatuses.slice();
        const tranStatusGroups = result.map(item => (
          {
            groupName: item.group,
            list: item.list,
          }
        )).flat();
        tranStatusGroups.forEach((groupName, outerIndex) => {
          tranStatusGroups[outerIndex].list.forEach((status, innerIndex) => {
            if (status.id === this.transaction.transStatus) {
              tranStatusGroups[outerIndex].showThisGroup = true;
              tranStatusGroups[outerIndex].list[innerIndex].showThisStatus = true;
            } else {
              tranStatusGroups[outerIndex].list[innerIndex].showThisStatus = false;
            }
          });
        });
        this.transactionStatusGroup = (tranStatusGroups.filter(x => x.showThisGroup)).flat();
        this.loading = false;
      }, 1000);
    },
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mmA');
    },
    formatExtractDate(value) {
      return moment(value).format('MM/DD/YYYY');
    },
    initialData() {
      return {
        dataLoaded: false,
        loading: true,
        loadingError: false,
        transactionStatusGroup: [],
        userPersonTypesCodes: null,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  td.align-bottom
    vertical-align: bottom
  .batch-category:last-child
    border-bottom: none
  .batch-category:last-child table .row-border:last-child
    border-bottom: none
  .column-header
    padding-left: 0px
  .font
    font-size: 14px
  .form-row
    line-height: 2rem
    padding-right: 0.5rem
  .form-row--overflow
    overflow: hidden
    text-overflow: ellipsis
  .font-weight
    font-weight: normal
  .has-text-light-grey
    color: #999999
  .loader-center
    text-align: center
    vertical-align: middle
    font-size: 24px
  .margin-bottom
    margin-bottom: 1rem
  .margin-bottom--small
    margin-bottom: 0.5rem
  .max-width
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    max-width: 20ch
  .record-count
    font-size: 14px
    color: #000 !important
  .removeUnderline
    border-bottom: 1px solid transparent !important
  .row-border
    border-bottom: 1px solid #dee2e6
  .text-align--left
    text-align: left !important
    padding-left: 0
  .text-align--right
    text-align: right !important
    padding-right: 0
  .form-table
    table-layout: fixed
    td
      overflow-wrap: break-word
      white-space: normal
  @media screen and (max-width: 60em)
    .columns
      display: block
      .column
        width: 100%
</style>
